module.exports = __webpack_public_path__ + "static/media/40-3.8926c8df.mp3";